import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Select, EAA_Memo, EAA_Btn, EAA_Time } from '~/components/EditAndAddItem';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import PageTitle from '~/components/PageTitle';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { re_account, re_email } from '~/skills/TextRules';

const modeInfo = {
  add: {
    title: '帳號新增',
  },
  edit: {
    title: '帳號編輯',
  },
  view: {
    title: '帳號檢視',
  },
  check: {
    title: '帳號編輯確認',
  },
};

class AddAndEdit extends Component {
  state={ userData: {}, old_userData: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getOrgList, getGroupList, getUserIdDetail, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    getOrgList();
    getGroupList();
    if (mode !== 'add')getUserIdDetail(id);
  }

  componentDidUpdate (preProps, preState) {
    const { userIdDetail: preUserIdDetail = {} } = preProps;
    const { userIdDetail = {}, mode, getOrgActList } = this.props;
    const { userData: preUserData = {} } = preState;
    const { userData = {} } = this.state;
    if (Object.keys(preUserIdDetail).length === 0 && Object.keys(userIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ userData: userIdDetail, old_userData: userIdDetail });
    }
    if ((userData.org_id || '').length > 0 && (preUserData.org_id !== userData.org_id)) {
      getOrgActList(userData.org_id);
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('UserIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '', object = {} }) => {
    const { userData } = this.state;
    let newData = { ...userData };
    if (label)newData[label] = data;
    newData = { ...newData, ...object };
    this.setState({ userData: newData });
  }

  add=() => {
    // this.setState({ canSend: false });
    const { userData: d } = this.state;
    const userData = JSON.parse(JSON.stringify(d));
    this.setState({ canSend: false });
    if (!userData.status)userData.status = '0';
    userData.name = userData.user_name;
    delete userData.user_name;
    this.props.postAddNewUser(userData);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    this.setState({ canSend: false });
    const { id, putUpdateUser } = this.props;
    const { userData: d } = this.state;
    const userData = JSON.parse(JSON.stringify(d));
    if (!userData.status)userData.status = '0';
    userData.name = userData.user_name;
    const bodyItem = [
      // 'deactivated_time',
      'email',
      'group_id',
      'memo',
      'mobile_number',
      'name',
      'org_id',
      'status',
      'tel_number',
      'manager_account_id',
    ];
    const body = {};
    for (let i = 0; i < bodyItem.length; i++) {
      if (userData[bodyItem[i]])body[bodyItem[i]] = userData[bodyItem[i]];
    }
    if (body.status === '2' && userData.deactivated_time && userData.deactivated_time.length > 0) { // deactivated_time
      body.deactivated_time = userData.deactivated_time;
    }
    putUpdateUser(id, body);
  }

  filterError=() => {
    const { userData = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      !re_account(returnInputValue(userData.account)),
      returnInputValue(userData.user_name) === '',
      returnInputValue(userData.org_id) === '',
      !re_email(returnInputValue(userData.email)),
      returnInputValue(userData.tel_number) === '',
      returnInputValue(userData.group_id) === '',
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { orgList = [], groupList = [], orgActList = [], mode = '' } = this.props;
    const { userData = {}, old_userData = {}, canSend, errorAry } = this.state;
    const { status = '0' } = userData;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck;
    // const { status = '0' } = userData;
    const checkChange = label => isCheck ? (userData[label] || '') !== (old_userData[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    const returnDate = () => {
      let text = '';
      if (userData.deactivated_time && userData.deactivated_time.length > 0) {
        text = userData.deactivated_time;
        while (text.match('/'))text = text.replace('/', '-');
        while (text.match(' '))text = text.replace(' ', 'T');
      }
      return text.length > 0 ? new Date(text) : text;
    };
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='使用者帳號' bol={true} haveChange={checkChange('account')} />
              <EAA_Input displayBorder disabled={disabled || isEdit} hint='AA001' value={returnInputValue(userData.account)} onChange={data => { this.changeData({ label: 'account', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText text='帳號需為 1 ~ 100 英數字。' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='姓名' bol={true} haveChange={checkChange('user_name')} />
              <EAA_Input displayBorder disabled={disabled} hint='AA001' value={returnInputValue(userData.user_name)} onChange={data => { this.changeData({ label: 'user_name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText text='請填寫姓名。' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='組織名稱' bol={true} haveChange={checkChange('org_id')} />
              <EAA_Select displayBorder disabled={disabled} list={orgList} value={returnInputValue(userData.org_id)} onChange={data => this.changeData({ object: { manager_account_id: '', org_id: data } })} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText text='請選擇組織單位。' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='電子信箱' bol={true} haveChange={checkChange('email')} />
              <EAA_Input displayBorder disabled={disabled} hint='請填入Email' value={returnInputValue(userData.email)} onChange={data => { this.changeData({ label: 'email', data }); }} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText text='電子郵件格式錯誤。' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='聯絡電話' bol={true} haveChange={checkChange('tel_number')} />
              <EAA_Input displayBorder disabled={disabled} hint='(02) 2655-1188#110' value={returnInputValue(userData.tel_number)} onChange={data => { this.changeData({ label: 'tel_number', data }); }} />
            </EAA_ItemContainer>
            {errorAry[4] && <EAA_ErrorText text='請填寫聯絡電話。' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='行動電話' haveChange={checkChange('mobile_number')} />
              <EAA_Input displayBorder disabled={disabled} hint='0968-111-222' value={returnInputValue(userData.mobile_number)} onChange={data => { this.changeData({ label: 'mobile_number', data }); }} />
            </EAA_ItemContainer>
            {/* <EAA_ErrorText text='請輸入行動電話。' /> */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='權限' bol={true} haveChange={checkChange('group_id')} />
              <EAA_Select displayBorder disabled={disabled} list={groupList} value={returnInputValue(userData.group_id)} onChange={data => { this.changeData({ label: 'group_id', data }); }} />
            </EAA_ItemContainer>
            {errorAry[5] && <EAA_ErrorText text='請選擇權限群。' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='主管帳號' haveChange={checkChange('manager_account_id')} />
              <EAA_Select displayBorder disabled={disabled || returnInputValue(userData.org_id) === ''} list={orgActList} value={returnInputValue(userData.manager_account_id)} onChange={data => { this.changeData({ label: 'manager_account_id', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[5] && <EAA_ErrorText text='請選擇權限群。' />} */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_ItemContainer>
            <EAA_TitleText text='狀態' bol={true} haveChange={checkChange('status') || checkChange('deactivated_time')} />
            {old_userData.status !== '1' && <CircleCheckBox disabled={!isEdit || disabled || (old_userData.status && old_userData.status === '0')} value={status === '0'} onClick={() => { this.changeData({ label: 'status', data: '0' }); }} />}
            {old_userData.status !== '1' && <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>未啟用</div>}
            <CircleCheckBox disabled={!isEdit || disabled || (old_userData.status && old_userData.status === '0')} value={status === '1'} onClick={() => { this.changeData({ label: 'status', data: '1' }); }} />
            <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>啟用</div>
            <CircleCheckBox disabled={!isEdit || disabled || (old_userData.status && old_userData.status === '0')} value={status === '2'} onClick={() => { this.changeData({ label: 'status', data: '2' }); }} />
            <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}> 停用</div>
            {status === '2' && (
              <EAA_Time
                displayBorder
                disabled={disabled}
                value={returnDate()}
                onChange={d => {
                  const text = `${d.getFullYear()}/${(d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : `0${d.getMonth() + 1}`}/${d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`} ${d.getHours() > 9 ? d.getHours() : `0${d.getHours()}`}:${d.getMinutes() > 9 ? d.getMinutes() : `0${d.getMinutes()}`}`;
                  this.changeData({ label: 'deactivated_time', data: text });
                }}
              />
            )}
          </EAA_ItemContainer>
        </EAA_Row>

        <EAA_Row>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            <EAA_TitleText text='備註說明' haveChange={checkChange('memo')} />
            <EAA_Memo displayBorder disabled={disabled} hint='例如: 使用者姓名，方便查閱' value={returnInputValue(userData.memo)} onChange={data => this.changeData({ label: 'memo', data })} />
          </div>
        </EAA_Row>

        <div style={{ height: 16 }} />

        {userData.add_time && (
          <EAA_Row>
            <EAA_ItemContainer>
              <EAA_TitleText text='註冊時間' />
              <div>{userData.add_time}</div>
            </EAA_ItemContainer>
          </EAA_Row>
        )}
        {userData.upd_time && <div style={{ height: 12 }} />}
        {userData.upd_time && (
          <EAA_Row>
            <EAA_ItemContainer>
              <EAA_TitleText text='上次更新時間' />
              <div>{userData.upd_time}</div>
            </EAA_ItemContainer>
          </EAA_Row>
        )}

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewUser' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutUpdateUser' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orgList: state.data.OrgList,
  groupList: state.data.GroupList,
  orgActList: state.data.OrgActList,
  userIdDetail: state.data.UserIdDetail,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getOrgList: () => Actions.getOrgList(dispatch),
  getGroupList: () => Actions.getGroupList(dispatch),
  getOrgActList: id => Actions.getOrgActList(dispatch, { id }),
  clearUserIdDetail: () => Actions.clearUserIdDetail(dispatch),
  getUserIdDetail: id => Actions.getUserIdDetail(dispatch, { id }),
  postAddNewUser: body => Actions.postAddNewUser(dispatch, { body }),
  putUpdateUser: (id, body) => Actions.putUpdateUser(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
